import React from 'react';
import { Box, Slide } from '@material-ui/core';
import { Header } from './Header';
import { ThreadMessage } from 'src/views/OmniChannel/types';
import { MessageItem } from '../MessageItem';

export const Notes = ({
    notes,
    onClose,
}: {
    notes: ThreadMessage[];
    onClose: () => void;
    onConversationDeleted?: () => void;
}) => {
    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: 'calc(100vh - 80px)',
                flex: 1,
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <Slide direction="up" in={true} timeout={600}>
                <Box
                    style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Header onClose={onClose} />

                    <div
                        style={{
                            minHeight: 0,
                            overflowY: 'scroll',
                            display: 'grid',
                            gridTemplateRows: 'auto auto minmax(0, 1fr)',
                            padding: 16,
                        }}
                    >
                        {notes.map((note) => (
                            <MessageItem
                                fullWidth
                                key={note.id}
                                message={note}
                                dateFormat="LLL"
                            />
                        ))}
                    </div>
                </Box>
            </Slide>
        </Box>
    );
};
